import { useState } from "react";
import { Link, useParams } from "react-router-dom";
import {
  arrow_left,
  email_icon, pdf_icon,
  pencil_icon,
  phone_icon,
  three_dots_menu
} from "../imagepath";
import DoctorsOverview from "./DoctorsOverview/DoctorsOverview";
import DoctorsFinance from "./DoctorsFinance/DoctorsFinance";
import DoctorsBookings from "./DoctorsBookings/DoctorsBookings";
import ConfirmDelete from "../modals/ConfirmDelete";
import FullscreenLoader from "../loadings/FullscreenLoader";
import { reduceArraytoString } from "../configs/reduceArraytoString";
import { useChangeDoctorStatus } from "../../hooks/doctors/useChangeDoctorStatus";
import ToggleModal from "../Hospitals/ToggleModal";
import TransparentTabs from "../tabs/TransparentTabs";
import { useDoctorsDocument } from "../../hooks/doctors/useDoctorsDocument";
import ComponentLoader from "../loadings/ComponentLoader";
import StatusButton from "../assests/StatusButton";
import { useDoctorAnalytics } from "../../hooks/doctors/useDoctorsAnalytics";
import ImageBox from "../assests/ImageBox";
import PropTypes from "prop-types";
import Review from "../Hospitals/Reviews/Review";
import { useDoctorReview } from "../../hooks/review/useDoctorReview";

function DoctorDetailsCard({ data, isLoading }) {
  const { id } = useParams();
  const { mutate, isLoading: statusChangeLoading } = useChangeDoctorStatus();
  const [show, setShow] = useState(false);
  const [disableshow, setdisableShow] = useState(false);
  const [disable, setdisable] = useState(false);
  const { data: doctorDocuments, isLoading: documentLoading } =
    useDoctorsDocument(id);
  const { data: doctorAnalytics, isLoading: analyticsLoading } =
    useDoctorAnalytics(id);
  const { data: doctorReview, isLoading: reviewLoading } = useDoctorReview(id);
  const tabData = [
    {
      id: "dr_overview",
      title: "Overview",
      content: <DoctorsOverview analytics={doctorAnalytics} />,
      link: "overview",
    },
    {
      id: "dr_finance",
      title: "Finance",
      content: <DoctorsFinance analytics={doctorAnalytics} />,
      link: "finance",
    },
    {
      id: "dr_bookings",
      title: "Total Bookings",
      content: <DoctorsBookings analytics={doctorAnalytics} />,
      link: "total-bookings",
    },
    {
      id: "dr_reviews",
      title: "Reviews",
      content: <Review reviews={doctorReview} isLoading={reviewLoading} />,
      link: "doctor-review",
    },
  ];

  const handleTogglebtn = (e) => {
    e.stopPropagation();
    setdisableShow(true);
  };
  const doctorStatus = data?.status;

  const handleDisable = async () => {
    const updatedStatus = {
      status: doctorStatus === "active" ? "disabled" : "active",
    };
    await mutate(
      { id: id, data: updatedStatus },
      {
        onSuccess: () => {
          setdisableShow(false);
        },
      }
    );
  };
  return (
    <div>
      <div className="card-box profile-header mt-3">
        <div className="row">
          <div className="d-flex justify-content-between">
            <div className="basic-hero-header">
              <Link to="/manage-doctors">
                <img src={arrow_left} alt="" />
              </Link>
              <span className="ms-3">Doctor Details</span>
            </div>
            <div className="dropdown">
              <Link
                // className="dropdown-toggle"
                to="#"
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                {/* <span className="bi bi-chevron-up"></span> */}
                <img src={three_dots_menu} alt="" />
              </Link>
              <div className="dropdown-menu">
                <Link
                  className="dropdown-item"
                  to={`/manage-doctors/${id}/edit`}
                >
                  <img
                    src={pencil_icon}
                    alt="edit"
                    className="dropdown-menu-icon"
                  />
                  <span>Edit</span>
                </Link>
                {/* <div className="dropdown-divider" /> */}
                <Link
                  className="dropdown-item"
                  to="#"
                  onClick={handleTogglebtn}
                >
                  <div
                    // onClick={handleTogglebtn}
                    className="status-toggle d-flex align-items-center"
                  >
                    <input
                      type="checkbox"
                      id="status"
                      className="check"
                      checked={doctorStatus === "active" ? true : false}
                    />
                    <label htmlFor="status" className="checktoggle-small">
                      checkbox
                    </label>
                    <span className="ps-2">
                      {doctorStatus === "active" ? "Disable" : "Enable"}
                    </span>
                  </div>
                </Link>
              </div>
            </div>
          </div>
        </div>

        <div className="row mt-5">
          <div className="col-md-4">
            <div className="row">
              <div className="col-md-3">
                <div className="">
                  <div className="">
                    <ImageBox
                      src={data?.profile_pic ?? ""}
                      alt="Doctor profile"
                      width="75x"
                      height="75px"
                    />
                    {/* <img
                      className="img-fluid"
                      src={data?.profile_pic}
                      alt="#"
                    /> */}
                  </div>
                </div>
              </div>
              <div className="col">
                <div className="profile-info-left pt-3">
                  <h3 className="user-name m-t-0 mb-0">Dr. {data?.name}</h3>
                  <small className="text-muted">
                    {data?.registration_details?.qualification}
                  </small>
                </div>
              </div>
            </div>
          </div>

          <div className="col-md-4 ps-md-5">
            <ul className="personal-info ps-md-5">
              <li>
                <span className="text">
                  <div className="text-dark">
                    <img src={phone_icon} alt="phone" />{" "}
                    <span className="ms-1">{data?.phone_number}</span>
                  </div>
                </span>
              </li>
              <li>
                <span className="text">
                  <div className="text-dark">
                    <img src={email_icon} alt="email" />{" "}
                    <span className="ms-1">{data?.email}</span>
                  </div>
                </span>
              </li>
            </ul>
          </div>

          <div className="col-md-4 pt-4 ps-md-5 pt-md-2">
            {/* <button className="btn hospital-draft-btn text-primary w-75 mt-1">
              {data?.status ?? "Inactive"}
            </button> */}

            <StatusButton status={data?.status ?? "Inactive"} />
          </div>
        </div>
        <div className="row mt-4">
          <div className="col-md-6">
            <div className="row border border-secondary-subtle pt-3 pb-1 ms-1 me-1">
              <div className="col">
                <ul className="payment-info w-1">
                  <li>
                    <span className="payment-title">
                      Education:{" "}
                      <span className="fw-semibold text-black">
                        {data?.registration_details?.qualification}
                      </span>
                    </span>
                  </li>
                  <li className="mt-3 mb-3">
                    <span className="payment-title">
                      Specialization:{" "}
                      <span className="fw-semibold text-black">
                        {reduceArraytoString(data?.specialisations)}
                      </span>
                    </span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="col-md-6">
            <div className="row border border-secondary-subtle pt-3 pb-1 ms-1 me-1">
              <div className="col">
                <ul className="payment-info w-1">
                  <li>
                    <span className="payment-title">
                      Account Number:{" "}
                      <span className="fw-semibold text-black">
                        {data?.bank_details?.account_number}
                      </span>
                    </span>
                  </li>
                  <li className="mt-3 mb-3">
                    <span className="payment-title">
                      Bank Name:{" "}
                      <span className="fw-semibold text-black">
                        {data?.bank_details?.bank_name}
                      </span>
                    </span>
                  </li>
                </ul>
              </div>
              <div className="col">
                <ul className="payment-info">
                  <li>
                    <span className="payment-title">
                      IFSC Code:{" "}
                      <span className="fw-semibold text-black">
                        {data?.bank_details?.ifsc}
                      </span>
                    </span>
                  </li>
                  <li className="mt-3 mb-3">
                    <span className="payment-title">
                      UPI ID:{" "}
                      <span className="fw-semibold text-black">
                        {data?.bank_details?.upi_id}
                      </span>
                    </span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        {doctorDocuments?.length > 0 && (
          <div className="row border border-secondary-subtle pt-3 pb-1 ms-1 me-1 mt-3 file-upload-card">
            <div className="row mb-1">
              <div className="col">
                <h5>Uploaded Documents</h5>
              </div>
            </div>

            {!documentLoading ? (
              <div className="mb-4">
                {doctorDocuments?.map((item, i) => {
                  return (
                    <div className="row mt-2" key={`row${item?.id}`}>
                      <div className="col-12 pt-2 col-md-2">
                        Document {i + 1}
                      </div>
                      <div className="col-12 col-md-10 md:mt-0 mt-1">
                        <div className="d-flex justify-content-between align-items-center file-upload-details ps-3 pe-3">
                          <div className="d-flex align-items-center">
                            <img src={pdf_icon} alt="pdf_icon" />
                            <div className="d-flex flex-column justify-content-center file-details ms-2">
                              <h6>{item.name}</h6>
                            </div>
                          </div>
                          <div className="d-flex">
                            <a
                              className="m-1"
                              href={`${item?.file}`}
                              target="_blank"
                              rel="noreferrer"
                            >
                              <i className="fa fa-eye text-black me-2" />
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            ) : (
              <ComponentLoader />
            )}
          </div>
        )}
      </div>
      <TransparentTabs tabData={tabData} />
      {isLoading || (analyticsLoading && <FullscreenLoader />)}
      <ConfirmDelete show={show} setShow={setShow} title="Doctors" />
      <ToggleModal
        show={disableshow}
        setShow={setdisableShow}
        setdisable={setdisable}
        disable={disable}
        title="Doctor"
        handleDisable={handleDisable}
        isLoading={statusChangeLoading}
      />
    </div>
  );
}

DoctorDetailsCard.propTypes = {
  data: PropTypes.object,
  isLoading: PropTypes.bool,
};

export default DoctorDetailsCard;
